import React from "react";
import { Table } from "reactstrap";
import { Icon } from "@cadmakers-ui/icons";
import iconStyles from "../../../Common/Styles/Icons.module.scss";
import { User } from "../..";
import UserSearchBarContainer from "./UserSearchBar/UserSearchBarContainer";
import { UserAutocompleteItem } from "../../../Layout/Models/AutocompleteItem";
import styles from "../../Styles/UserAssigner.module.scss";

type Props = {
  assignedUsers: User[];
  assignTo: string; // this is the name of the thing we are assigning users to
  onUserAssigned: (user: User) => void;
  onUserRemoved: (user: User) => void;
};

export default class UserAssigner extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    this.onSelectUser = this.onSelectUser.bind(this);
  }

  onSelectUser(user: UserAutocompleteItem) {
    this.props.onUserAssigned({
      id: user.userId,
      name: user.itemName,
      username: user.code,
      email: user.email
    });
  }

  render() {
    return (
      <div>
        <UserSearchBarContainer
          onSelectUser={this.onSelectUser}
          placeholder="Find a user to assign..."
          icon={
            <Icon
              appName="GeneralLayout"
              assetName="GENERAL_L_Plus"
              className={iconStyles.smallIcon}
            />
          }
        />
        <br />
        <Table>
          <thead>
            <tr>
              <th colSpan={2}>Assigned Users</th>
            </tr>
          </thead>
          <tbody>
            {this.props.assignedUsers.map(el => {
              const buttonTitle = `Remove this user from ${this.props.assignTo}`;

              return (
                <tr key={el.id}>
                  <td>{el.name}</td>
                  <td>
                    <a
                      className={styles.unassignUserButton}
                      title={buttonTitle}
                      onClick={() => {
                        this.props.onUserRemoved(el);
                      }}
                    >
                      <Icon
                        appName="GeneralLayout"
                        assetName="GENERAL_L_RemoveX"
                        className={iconStyles.smallIcon}
                      />
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}
